import React, { useEffect } from "react";
import { useMeritEngineNavigation } from "./useMeritEngineNavigation";
import ModDas from "./ModDas";
import ModRuvnlPriceAnalysis from "./ModDashboard/LoadPrice";
import RuvnlFileUploadTabComponent from "./Resource/Upload/Upload";
import ModRuvnlChartTable from "./Mod/ModTable/ModIndex";
import RuvnlSellBidTable from "./Bid/BidIndex";
import ModRuvnlSimulationIndex from "./ModSimulation/ModSimulationIndex";
import ModRuvnlArchive from "./ModArchive/ModArchive";
import { getModRuvnlSession } from "../Utility/RestApi";
import { ModRuvnlSelectedDate } from "../../../store/state/ModRuvnl/ModDate";
import { setModRuvnlSession } from "../../../store/state/ModRuvnl/ModSession";
import { setModRuvnlVersion } from "../../../store/state/ModRuvnl/ModVersion";
import { setModRuvnlSessionToken } from "../../../store/state/ModRuvnl/ModSessionToken";
import { useDispatch } from "react-redux";

const MeritEngineRouter: React.FC = () => {
  const { currentPage } = useMeritEngineNavigation();
  const dispatch = useDispatch();

  // useEffect to handle page refresh and navigation
  // useEffect(() => {
  //   // This component only renders when currentPage is 'dashboard' or null/undefined
  //   // The MeritEngineRouter handles rendering other pages
  //   console.log("ModDas rendered with currentPage:", currentPage);
  // }, [currentPage]);

  useEffect(() => {
    async function ModRuvnlSession() {
      const data = await getModRuvnlSession();
      if (data) {
        dispatch(ModRuvnlSelectedDate(data.date));
        dispatch(setModRuvnlSession(data.session));
        dispatch(setModRuvnlVersion(data.version));
        dispatch(setModRuvnlSessionToken(data.session_token));
      }
    }
    ModRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "load-price":
        return <ModRuvnlPriceAnalysis />;
      case "resources":
        return <RuvnlFileUploadTabComponent />;
      case "merit-order-dispatch":
        return <ModRuvnlChartTable />;
      case "bid":
        return <RuvnlSellBidTable />;
      case "simulation-generation":
        return <ModRuvnlSimulationIndex />;
      case "archive":
        return <ModRuvnlArchive />;
      case "dashboard":
      case null:
      case undefined:
      default:
        return <ModDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default MeritEngineRouter;
